export enum DateStyle {
  Date = 'date',
  DateWithoutYear = 'dateWithoutYear',
  Time = 'time',
  ShortDate = 'shortDate',
  ShortDateTime = 'shortDateTime',
  DateTime = 'dateTime',
}
